var ablyRestApiHardwareChannel = require('./ablyRestApiHardwareChannel.js');

export function publishMessage(payload)
{
    ablyRestApiHardwareChannel.publishMessage(payload);
}
